<template>
  <div id="settingWrap_home">
    <a-layout>
      <div class="workshopHeader">
        <a-row :class="handleScrollTop ? 'headerContainScroll' : 'headerContain'" ref="headerContain">
          <a-col :span="5"></a-col>
          <a-col :span="13" class="workshopHeader_msg">
            <h2>{{attInfo.attTitle}}</h2>
            <div class="workshopHeader_data">
              <a-row type="flex">
                <a-col :span="8">
                  <span>批改形式：</span>
                  <span v-if="attInfo.checkType == 'auto'">自动批改</span>
                  <span v-if="attInfo.checkType == 'manual'">手动批改</span>
                  <span v-if="attInfo.checkType == ''">未设置</span>
                </a-col>
                <a-col :span="8" class="queNum">
                  <span>题目数量：</span>
                  <span>{{attInfo.assignmentCount}}</span>
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="6" style="display: flex;align-items: flex-end;justify-content: flex-end;padding: 0 40px 20px 0">
            <div class="btnGroups">
              <a-button @click="backCouserwork()">返回</a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-layout>
        <a-layout-sider width="240" :class="handleScrollTop ? 'sidebarScroll' : 'sidebar'" :style="{ position: 'fixed', borderRight: '2px solid #E9E9E9' }" ref="sidebar">
          <a-menu :defaultSelectedKeys="['/settingWrapTest']" :selectedKeys="[fullPath]" mode="inline" :style="{ height: '100vh', borderRight: 0 }">
            <a-menu-item :key="'/settingWrapTest'">
              <router-link :to="{ path: '/settingWrapTest' }">
                <a-icon type="home" />
                <span>作业设置</span>
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout-content :style="{ marginLeft: '240px', background: '#fff', minHeight: 'calc(100vh - 164px)' }">
          <div class="workshopSetting">
            <div class="componentTop">
              <div class="componentText">作业设置</div>
            </div>
            <div>
              <a-tabs defaultActiveKey="1">
                <a-tab-pane tab="基本信息" key="1">
                  <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                  >
                    <a-form-model-item label="作业标题：" prop="attTitle">
                      <a-input v-model="form.attTitle" placeholder="请输入作业标题，不超过100字" />
                    </a-form-model-item>
                    <a-form-model-item label="作业要求：" prop="attDes">
                      <editor
                          @getEditorHtml="getEditorHtml"
                          :editorHtml="formattDes"
                          ref="editor"
                      ></editor>
                      <!-- <a-input v-model="form.attDes" type="textarea" rows="5" placeholder="请简单描述本次作业的要求，不超过200字" /> -->
                    </a-form-model-item>
                    <a-form-model-item label="批改方式" prop="isDisplayParsing">
                      <a-radio-group>
                        <a-radio default-checked :disabled="true">
                          自动批改
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="显示解析" prop="isDisplayParsing">
                      <a-radio-group v-model="form.isDisplayParsing">
                        <a-radio value="Y" default-checked >
                          显示
                        </a-radio>
                        <a-radio value="N">
                          不显示
                        </a-radio>
                      </a-radio-group>
                      <span class="c9B">&emsp;说明：选择了显示后，在学员提交了答卷后，可查看每一道题目的答案及解析</span>
                    </a-form-model-item>
                    <a-form-model-item label="作业分数" prop="isDisplayParsing">
                      <a-radio-group>
                        <a-radio default-checked :disabled="true">
                          按最高分数
                        </a-radio>
                      </a-radio-group>
                      <span class="c9B">&emsp;说明：若试卷可以多次考核，按照最高分数作为作业的分数</span>
                    </a-form-model-item>
                    <a-form-model-item label="考核次数" prop="allowAnswerCount">
                      <a-input-number v-model="form.allowAnswerCount" :min="0" :max="99"/>
                      <span class="c9B">&emsp;说明：允许学员考核的次数，0代表无限次，范围为0 ~ 99次</span>
                    </a-form-model-item>
                    <a-form-model-item label="答题时间" prop="allowAnswerTime">
                      <a-input-number v-model="form.allowAnswerTime" :min="0" :max="360"/>
                      <span class="c9B">&emsp;说明：学员单次考试答题时间，0代表无限制，范围为0 ~ 360分钟</span>
                    </a-form-model-item>
                    <a-form-model-item label="题目内容">
                      <a-button class="mar5px" @click="download">下载附件</a-button>
                      <a-upload
                          :accept="'.doc, .docx, .excel, .ppt, .pptx, .xls, .xlsx, .pdf, .txt'"
                          :action="apis.coursedetail.excelimport + appUtils.getResearchId()"
                          :transformFile="transformFile"
                          :beforeUpload="beforeUploadVideoExcelImport"
                          :fileList="fileListVideoExcelImport"
                          @change="fileListVideoExcelImport1"
                          :showUploadList="false"
                          :remove="removeFile"
                          :headers="{
                              'Authorization': 'Bearer ' + appUtils.getToken()
                          }"
                      >
                        <div class="uploadBtn df">
                            <a-button class="mar5px" type="primary">上传文件</a-button>
                        </div>
                      </a-upload>
                      <a-button class="mar5px" type="primary" :disabled="voteImportDisable" @click="showVoteSubjectList">题目预览</a-button>
                      <span style="color:red;">&emsp;注意：多次上传文件，只会保存最新的问卷内容，原有的内容都会被删除！</span>
                    </a-form-model-item>
                    <a-form-model-item label="完成要求" prop="finishCondition">
                      <a-radio-group v-model="form.finishCondition">
                        <a-radio value="1">
                          完成测试题目并提交
                        </a-radio>
                        <a-radio value="2">
                          完成测试题目并提交，成绩达到
                          <a-input-number v-model="form.requireScore" :min="0" :max="100"/>
                          分以上
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :wrapper-col="{ span: 4, offset: 4 }">
                        <a-button @click="submit" type="primary">保存</a-button>
                    </a-form-model-item>
                  </a-form-model>
                </a-tab-pane>
                <!-- <a-tab-pane tab=高级设置 key="2" forceRender>
                  
                </a-tab-pane> -->
              </a-tabs>
            </div>
          </div>
          <div style="height: 200px;" v-if="contentBottom"></div>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <a-modal
      title="测试题目预览"
      :visible="returnVoteSubjectListvisible"
      @cancel="returnVoteSubjectListhandleOk"
      :width="1100"
      :footer="null"
    >
        <question
            :voteSubjectList="voteSubjectList"
        ></question>
        <div style="text-align: right;padding: 10px 0;">
            <a-button :style="{ marginRight: '8px' }" @click="()=>{returnVoteSubjectListvisible = false;}">
                    取消
            </a-button>
        </div>
    </a-modal>
    <div class="exampleTest" v-show="show">
      <a-spin class="exampleTestexampleTest"/>
    </div>
  </div>
</template>

<script>
import basciMessage from './basciMessage';
import question from './question';

import Editor from './../../../../components/Editor.vue';

// import { Icon } from 'ant-design-vue';
// const IconFont = Icon.createFromIconfontCN({
//   scriptUrl: require('../../../static/js/iconfont.js')
// });
export default {
  // components: {
  //   IconFont
  // },
  components: {
    basciMessage,
    question,
    Editor
  },
  data(){
    return {
      handleScrollTop: false,
      contentBottom: false,
      groupInfo: {},
      gruopNum: {},
      fullPath: '',
      attinfoId: '',
      attInfo: {},
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      taskCoverNum: 5,
      fileListVideoExcelImport: [],
      voteSubjectList:[],
      voteImportDisable: true,
      returnVoteSubjectListvisible: false,
      show:false,
      form: {
        attTitle: '',
        attDes: '',
        allowAnswerCount: '',
        isDisplayParsing: '',
        allowAnswerTime: '',
        finishCondition: '1',
        requireScore: '',
      },
      rules: {
        attTitle: [
          { required: true, message: '请输入作业标题', trigger: 'blur' },
          { max: 100, message: '最多输入100个字符', trigger: 'blur' }
        ],
        attDes: [
          { required: true, message: '请简单描述本次作业的要求', trigger: 'blur' },
          // { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ],
        isDisplayParsing: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        allowAnswerCount: [
          { required: true, message: '请填写考核次数', trigger: 'blur' }
        ],
        allowAnswerTime: [
          { required: true, message: '请填写答题时间', trigger: 'blur' }
        ],
        workQuestions: [
          { required: true, message: '请上传题目内容', trigger: 'change' }
        ],
        finishCondition:[
          { required: true, message: '请选择完成要求', trigger: 'change' }
        ]
      },
      editorRes : '',
      formattDes : '',
    };
  },
  created () {
    this.attinfoId = this.appUtils.getCourseInfo().attinfoId;
    this.getOneAttInfo();
    this.fullPath = this.$route.fullPath;
  },
  mounted () {
    var that = this;
    window.onscroll = function(){
      that.handleScroll();
    };
  },
  updated () {
    this.fullPath = this.$route.fullPath;
  },
  methods: {
    // 获取html 并提交表单
    getEditorHtml(res){
        console.log(res);
        // if (!this.title){
        //     this.$message.error('标题不能为空');
        //     return;
        // }
        // if (!this.articleType){
        //     this.$message.error('类型不能为空');
        //     return;
        // }
        if (res == '<p><br></p>'){
            this.$message.error('内容不能为空');
            return
        }
        this.editorRes = res;
        this.submit1();
        // // console.log(res);
        // this.openFullScreen();
        // this.http.postAuth(this.apis.workSpace.articleSave, {
        //     'articleType': this.articleType,
        //     'content': res,
        //     'groupId': this.groupId,
        //     'title': this.title,
        //     'realName':this.appUtils.getUserName(),
        //     'createdBy':this.appUtils.getUserId(),
        //     'userId':this.appUtils.getUserId()
        // }).then(res => {
        //     console.log(res);
        //     this.$message({
        //         message: '添加文章成功',
        //         type: 'success'
        //     });
        //     this.$router.push({ path: '/workSpace/article' });
        // }).catch(err => {
        //     this.$message.error('添加文章失败');
        //     console.log(err);
        // });
    },
    download(){
      window.open(this.apis.coursework.downloadTemplate);
    },
    showVoteSubjectList(){
      console.log(this.voteSubjectList);
      if (this.voteSubjectList.length > 0){
        this.returnVoteSubjectListvisible = true;
      }
    },
    // 文件上传前检测
    beforeUploadVideoExcelImport(file, fileList){
      console.log(file);
      if (file.name.indexOf('xlsx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('XLSX') > 0 || file.name.indexOf('XLS') > 0){
          const isLt2M = file.size/1024/1024 < 50;
          if (!isLt2M) {
              this.$message.error('单个文件大小不超过50M!');
              this.loading = false;
              return false;
          }
          
          var formFile = new FormData();
          formFile.append("file", file);

          this.http.postFormData(this.apis.coursework.excelimport + this.appUtils.getResearchId(), formFile).then(res => {
              // console.log(res);
              this.voteSubjectList = res.data;

              if (res.data.length == 0){
                  this.$message.error('上传文件失败');
                  this.voteImportDisable = true;
              } else {
                  this.$message.success('上传文件成功');
                  this.voteImportDisable = false;
              }
          }).catch(err => {
              this.$message.error('上传文件失败');
          })
          
      } else {
          fileList = [];
          this.$nextTick(function () {
              this.fileListVideoExcelImport = [];
          });
          this.$message.error('上传文件不符');
          return false;
      }
      
      return false;
    },
    returnVoteSubjectListhandleOk(){
      this.returnVoteSubjectListvisible = false;
    },
    // 问卷上传后回调
    fileListVideoExcelImport1(res){
      console.log(res);
    },
    removeFile(){
      this.$message.error('已上传文件不支持删除，可重新上传');
      return false;
    },
    transformFile(file){
      console.log(file);
      return new Promise(resolve => {
        resolve();
      });
    },
    backCouserwork(){
      this.$router.push({path: '/courseworkSetting'});
    },
    getOneAttInfo(){
      let url = this.apis.coursework.getOneAttInfoById + this.attinfoId;
      this.http.get(url)
      .then((res)=>{
        console.log(res);
        // "attinfoId": this.attinfoId,
        // "researchId": this.appUtils.getResearchId(), //课程id
        // "attTitle": this.form.attTitle, //题目标题
        // "attDes": this.form.attDes, //作业描述
        // "checkType": "auto", //写死
        // "attType": "work", //资源类型: work写死
        // "allowAnswerCount": this.form.allowAnswerCount, //允许学员回答的次数
        // "workType": "test", //作业类型(附件题:attachment 测试题:test)
        // "isDisplayParsing": this.form.isDisplayParsing, //是否显示解析
        // "allowAnswerTime": this.form.allowAnswerTime, //答题时间
        // "finishCondition": this.form.finishCondition, //1:完成测试题目并提交 2:完成测试题目并提交，成绩达到*分以上
        // "requireScore": this.form.requireScore, //要求的分数
        // "workQuestions": this.voteSubjectList
        this.form.attTitle = res.data.attTitle;
        this.form.attDes = res.data.attDes;
        this.formattDes = res.data.attDes;
        this.$refs.editor.setEditor(res.data.attDes);
        this.form.allowAnswerCount = res.data.allowAnswerCount;
        this.form.isDisplayParsing = res.data.isDisplayParsing;
        this.form.allowAnswerTime = res.data.allowAnswerTime;
        this.form.finishCondition = res.data.finishCondition || '1';
        this.form.requireScore = res.data.requireScore;
        this.voteSubjectList = res.data.workQuestions;
        if (res.data.workQuestions.length > 0){
          this.voteImportDisable = false;
        }

        this.attInfo = res.data;
        // this.$store.dispatch('setCourseInfoFunction', res.data);
      }).catch((err)=> {
        console.log(err);
      });
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        this.handleScrollTop = true;
        this.contentBottom = true;
      } else {
        this.handleScrollTop = false;
        this.contentBottom = false;
      }
    },
    submit(){
      this.$refs.editor.getEditor();
    },
    submit1(){
      console.log(this.form);
      if (this.voteSubjectList.length == 0){
        this.$message.error('请上传题目内容');
        return false;
      }
      this.form.attDes = this.editorRes;
      this.$nextTick(function () {
        this.$refs.ruleForm.validate(valid => {
          console.log(this.form);
          if (valid) {
            this.show = true;
            console.log(valid);
            this.http.post(this.apis.coursework.saveOrUpdateWorkQuestion, {
              "attinfoId": this.attinfoId,
              "researchId": this.appUtils.getResearchId(), //课程id
              "attTitle": this.form.attTitle, //题目标题
              "attDes": this.editorRes, //作业描述
              "checkType": "auto", //写
              "attType": "work", //资源类型: work写
              "allowAnswerCount": this.form.allowAnswerCount, //允许学员回答的次数
              "workType": "test", //作业类型(附件题:attachment 测W试题:test)
              "isDisplayParsing": this.form.isDisplayParsing, //是否显示解析
              "allowAnswerTime": this.form.allowAnswerTime, //答题时间
              "finishCondition": this.form.finishCondition, //1:完成测试题目并提交 2:完成测试题目并提交，成绩达到*分以上
              "requireScore": this.form.requireScore, //要求的分数
              "workQuestions": this.voteSubjectList
            }).then(res => {
                console.log(res);
                this.$message.success('保存成功');
                this.$router.push({path: '/courseworkSetting'});
                this.show = false;
            }).catch(err => {
                this.$message.error('上传文件失败');
                this.show = false;
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      });
    }
  }
};
</script>

<style lang="less">
#settingWrap_home {
  &>*{
    box-sizing: border-box;
  }
  .ant-layout-header{
    background: #fff;
  }
  .ant-layout-sider {
    background: #fff;
  }
  .sidebar {
    max-height: calc(100vh - 215px);
  }
  .sidebarScroll {
    max-height: calc(100vh - 114px);
  }
  .ant-menu{
    text-align: left;
  }
  .workshopHeader{
    background: url('../../../../../static/images/yxHome_bg.png') no-repeat;
    background-size: 100% 100%;
    min-height: 100px;
    .headerContain{
      height: 100px;
      padding-top: 20px;
    }
    .headerContainScroll{
      width: 100%;
      height: 100px;
      position: fixed;
      top: 64px;
      background: #fff;
      padding-top: 10px;
      z-index: 20;
      border-bottom:1px solid rgba(232,232,232,1);
      box-shadow:0px 4px 12px rgba(238,238,238,1);
    }
    .ant-col{
      height: 100%;
    }
    .workshopHeader_msg{
      text-align: left;
      h2{
        height: 30px;
        line-height: 30px;
        font-size: 20px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
          display: inline-block;
          width:52px;
          height:22px;
          line-height: 22px;
          background:rgba(246,255,237,1);
          border:1px solid rgba(183,235,143,1);
          border-radius:4px;
          font-size: 12px;
          color:rgba(82,196,26,1);
          text-align: center;
          margin-left: 10px;
        }
      }
      h4{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
      }
      .workshopHeader_data{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
        .queNum{
          margin-left: 20px;
          span:nth-child(2){
            color: #1890FF;
          }
        }
      }
    }
    .btnGroups{
      .ant-btn{
        margin-left: 17px;
      }
    }
  }
}
.workshopSetting{
  text-align: start;
  .ant-tabs-nav-wrap{
    padding-left: 20px;
  }
  .componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .componentText{
    font-size: 30px;
    color: #333333;
  }
}
.c9B{
  color: #9B9B9B;
}
.mar5px{
  margin-right: 5px;
}
.exampleTest {
  text-align: center;
  background: rgba(0, 0, 0, 40%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100000;
}
.exampleTestexampleTest{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
